import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class GlobalErrorService {

  public readonly error$ = new EventEmitter<any>();

  constructor() {
  }

  emit(error) {
    this.error$.emit(error);
  }

  get() {
    return this.error$;
  }

  set(error) {
    this.error$.emit(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/error/error.service.ts